var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.$route.path !== '/dashboard')?_c('v-breadcrumbs',{staticClass:"primary--text font-weight-medium d-print-none pl-0",attrs:{"divider":"/","items":_vm.breadcrumbs}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }